import { uniqBy } from 'lodash-es';

import type { ReportingBlockDto } from '@src/api';

type ReportWithChildrenDtoDefId = ReportingBlockDto & {
  children?: ReportWithChildrenDtoDefId[];
  key: string | number;
  title: string;
};

export const toTreeView = (reports: ReportingBlockDto[]): ReportWithChildrenDtoDefId[] =>
  uniqBy(reports, 'reportTypeCode').map((ver) => ({
    key: ver.reportTypeCode ?? '',
    title: ver.reportTypeCode ?? '',
    children: reports
      .filter((a) => a.reportTypeCode === ver.reportTypeCode)
      .map((el) => ({
        key: el.id ?? '',
        title: `${el.name} - ${el.reportVersionName}`,
      })),
  })) ?? [];
